import React from 'react';
import {
    withStyles,
    Grid,
    Button,
    ButtonBase,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import Apis from '../../network/Apis';
import AppUtils from '../../control/apputlis';
import PreviewTwoItem from '../view/PreviewTwoItem';
import MNoLiving from '../view/MNoLiving';



class HistoryDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    componentDidMount() {
        this.encryptionHostLive();
        AppUtils.YMPush('MAIN', 'HistoryDialog');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    encryptionHostLive = async () => {
        let result = await Apis.encryptionHostLive();
        if (result.code == 200) {
            this.setState({ data: result.data });
        }
    }

    render() {
        const { classes } = this.props;
        const { data } = this.state;
        let datas = AppUtils.processList(data, 2);
        return (
            <MBack title='历史观看'>
                <Grid container direction='column' alignItems='center' className={classes.content}>
                    {
                        datas.length > 0 && datas.map((item, i) => (
                            <PreviewTwoItem key={i} data={item} />
                        ))
                    }
                    {
                        data.length == 0 && <Grid style={{ marginTop: 32 }}>
                            <MNoLiving />
                        </Grid>
                    }
                </Grid>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    content: {
        marginTop: theme.spacing(2),
    },
}))(HistoryDialog));